"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DataProvider = exports.DataContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));

var _sub = _interopRequireDefault(require("date-fns/sub"));

var _getjobData = _interopRequireDefault(require("./getjobData"));

var _authProvider = _interopRequireDefault(require("./authProvider"));

var _getUserData = _interopRequireDefault(require("./getUserData"));

var _getLessorData = _interopRequireDefault(require("./getLessorData"));

var _getExpenseData = _interopRequireDefault(require("./getExpenseData"));

var _getAdditionalHoursData = _interopRequireDefault(require("./getAdditionalHoursData"));

var _getHolidaysData = _interopRequireDefault(require("./getHolidaysData"));

var _getNotificationData = _interopRequireDefault(require("./getNotificationData"));

var _getParams = _interopRequireDefault(require("./getParams"));

var _useAuth = require("../hooks/useAuth");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DataContext = /*#__PURE__*/_react["default"].createContext();

exports.DataContext = DataContext;
var Provider = DataContext.Provider;
/**
 * Data provider
 * @param {object} obj user data available
 * @returns {Provider} React component data provider
 */

var DataProvider = function DataProvider(_ref) {
  var children = _ref.children,
      restrictedData = _ref.restrictedData;

  var _useState = (0, _react.useState)((0, _startOfDay["default"])(new Date())),
      _useState2 = _slicedToArray(_useState, 2),
      minDate = _useState2[0],
      setRMinDate = _useState2[1];

  var setMinDate = (0, _react.useCallback)(function (d) {
    return setRMinDate(function (cur) {
      console.log('setMinDate', d);

      if (d < cur) {
        return (0, _sub["default"])(d, {
          days: 7
        });
      }

      return cur;
    });
  }, []);
  var auth = (0, _authProvider["default"])();
  var users = (0, _getUserData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser
  });
  var lessors = (0, _getLessorData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser
  });
  var params = (0, _getParams["default"])({
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser
  });
  var expense = (0, _getExpenseData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser
  });
  var additionatHours = (0, _getAdditionalHoursData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser
  });
  var holidays = (0, _getHolidaysData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser,
    minDate: minDate
  });
  var jobs = (0, _getjobData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser,
    minDate: minDate
  });
  var notifications = (0, _getNotificationData["default"])({
    restrictedData: restrictedData,
    user: auth === null || auth === void 0 ? void 0 : auth.fireBaseuser
  });
  return /*#__PURE__*/_react["default"].createElement(Provider, {
    value: {
      users: users,
      lessors: lessors,
      params: params,
      jobs: jobs,
      expense: expense,
      notifications: notifications,
      additionatHours: additionatHours,
      holidays: holidays,
      auth: auth,
      minDate: minDate,
      setMinDate: setMinDate
    }
  }, children);
};

exports.DataProvider = DataProvider;
DataProvider.propTypes = {
  restrictedData: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = DataProvider;
exports["default"] = _default;